import api from "@helpers/api";

import { InitiateTransferType } from "@type/HRM/transfer-candidates";

const apiEndPoint = `${process.env.REACT_APP_TRANSFER_SERVICE_URL}${process.env.REACT_APP_TRANSFER_SERVICE_PORT}/${process.env.REACT_APP_TRANSFER_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}`;

export const initiateTransfer = (() => {
  return async (
    data: InitiateTransferType,
    afterEffect: (param: any) => void,
  ): Promise<{ data: any }> => {
    return api
      .post(`${apiEndPoint}/transfers`, { employeeId: data })
      .then((response) => {
        afterEffect({
          data: response,
          status: "success",
        });

        return {
          data: response.data,
        };
      })
      .catch((response) => {
        afterEffect({
          data: response,
          status: "failed",
        });
        return {
          data: response,
        };
      });
  };
})();

export const interchangeTransfer = (() => {
  return async (
    data: InitiateTransferType,
    afterEffect: (param: any) => void,
  ): Promise<{ data: any }> => {
    return api
      .post(`${apiEndPoint}/exchange-transfers`, data)
      .then((response) => {
        afterEffect({
          data: response,
          status: "success",
        });

        return {
          data: response.data,
        };
      })
      .catch((response) => {
        afterEffect({
          data: response,
          status: "failed",
        });
        return {
          data: response,
        };
      });
  };
})();
